import type { BadgeProps } from '@chakra-ui/react'
import { Badge } from '@chakra-ui/react'

export interface SelectedBadgeProps extends BadgeProps {
  text?: string | React.ReactNode
}

export const SelectedBadge = ({ sx, text, ...rest }: SelectedBadgeProps) => {
  return (
    <Badge
      colorScheme="green"
      variant="solid"
      sx={{
        ...sx,
        zIndex: '1' // pridano kvuli prekryti loading boxem
      }}
      {...rest}
    >
      {text && text}
      {!text && 'Vybraná'}
    </Badge>
  )
}
